module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 29
// module chunks = 0